import { render, staticRenderFns } from "./aside-menu.vue?vue&type=template&id=d89f20ce"
import script from "./aside-menu.ts?vue&type=script&lang=js&external"
export * from "./aside-menu.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports